<template>
	<div class="w_100">
		<template v-if="hasDecision">
			<span class="text-dense text_left" :class="[cssClass, { 'pointer': hasReactedToDecision }]"
				  @click="() => hasReactedToDecision && checkDecision()"
			>
				<i class="fa" :class="icon" style="margin-right: 5px;"></i>
				<i v-visible="hasReactedToDecision" class="fa fa-external-link"></i>
			</span>
		</template>
		<template v-else>
			<span> {{ $t("common.value.notAvailable")}}</span>
		</template>
	</div>
</template>

<script>

import {enumDef} from "@/common/enumDefs";
import {isValueSet} from "@/common/format";

export default {
	computed: {
		status() {
			return this.params.data[this.params.colDef.field];
		},
		cssClass() {
			return enumDef.MarketSoundingStatus.properties[this.status].cssClass;
		},
		icon() {
			return enumDef.MarketSoundingStatus.properties[this.status].icon;
		},
		hasDecision() {
			return isValueSet(this.status);
		},
		hasReactedToDecision() {
			return this.hasDecision && [enumDef.MarketSoundingStatus.Interested, enumDef.MarketSoundingStatus.NotInterested].includes(this.status);
		}
	},
	methods: {
		checkDecision() {
			this.params.checkDecision(this.params.data);
		}
	}
};
</script>